import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.svg";
import Toolstack from "./Toolstack";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        {/* Intro Section */}
        <Row className="align-items-center" style={{ padding: "40px 0" }}>
          <Col
            md={7}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              paddingBottom: "30px",
            }}
          >
            <h1 className="section-heading">
              About <span className="accent-color">Me</span>
            </h1>
            <p className="section-subtitle">
              Get to know more about my background, skills, and tools I work with.
            </p>
            <Aboutcard />
          </Col>

          <Col md={5} className="about-img text-center">
            <img
              src={laptopImg}
              alt="about"
              className="img-fluid"
              style={{ maxHeight: "350px" }}
            />
          </Col>
        </Row>

        {/* Skills Section */}
        <h1 className="section-heading text-center">
          Professional <span className="accent-color">Skillset</span>
        </h1>
        <p className="section-subtitle text-center">
          Technologies and languages I have hands-on experience with:
        </p>
        <Techstack />

        {/* Tools Section */}
        <h1 className="section-heading text-center">
          <span className="accent-color">Tools</span> I Use
        </h1>
        <p className="section-subtitle text-center">
          Essential tools and platforms that streamline my development workflow:
        </p>
        <Toolstack />

        {/* GitHub Section */}
        {/* <h1 className="section-heading text-center">
          <span className="accent-color">GitHub</span> Contributions
        </h1>
        <p className="section-subtitle text-center">
          A snapshot of my open-source journey and project collaborations:
        </p>
        <Github /> */}
      </Container>
    </Container>
  );
}

export default About;

